import { useFormik } from "formik";
import * as Yup from "yup";
import { cancelEstimate } from "../../api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const useCancelRecheckModal = ({
  refetch,
  handleClose,
  selectedId,
  dispatch,
  updateConfig,
}) => {
  const navigate = useNavigate();
  const initialValues = {
    cancelreason: "",
  };
  const validation = Yup.object({
    cancelreason: Yup.string().required("Enter reason for cancellation"),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: validation,
    onSubmit: async (values) => {
      const params = {
        estimate_id: selectedId?.[0],
        reason: values.cancelreason,
      };
      cancelEstimate(params).then((response) => {
        if (response?.data?.status_code === 200) {
          toast.success(
            response?.data?.message ??
              "Certificate added to recheck list successfully"
          );
          dispatch(
            updateConfig((state) => {
              state.BillEstimate.cancelEstimateState = true;
            })
          );
          navigate({
            pathname: "/billing/bill-estimate",
            search: `activeTab=${"cancelled"}`,
          });
          handleClose();
          refetch();
        } else {
          toast.error("Something went wrong");
          handleClose();
          refetch();
        }
      });
    },
  });

  return { formik };
};
export default useCancelRecheckModal;
